/**
 * Klaviyo Custom Event Tracking for The Pet Poster
 * Tracks key user actions in the pet poster and photo poster tools.
 *
 * Events:
 * - Started Design (tool opened)
 * - Selected Style (illustration chosen — pet poster only)
 * - Uploaded Pet Photo
 * - Generated Portrait (pet poster only)
 * - Applied Filter (photo poster only)
 * - Customized Text
 * - Added to Cart
 */

(function () {
  'use strict';

  // Debounce helper for text input tracking
  var _textTimer = null;

  function track(eventName, properties) {
    properties = properties || {};
    properties.timestamp = new Date().toISOString();
    properties.page_url = window.location.href;

    // Klaviyo push
    if (window.klaviyo) {
      window.klaviyo.push(['track', eventName, properties]);
    }

    // Send to GA4 via gtag
    if (window.gtag) {
      var ga4Event = 'pp_' + eventName.toLowerCase().replace(/\s+/g, '_');
      gtag('event', ga4Event, properties);
    }
  }

  // Detect which tool we're on
  var isPetPoster = !!document.querySelector('.petposter-template');
  var isPhotoPoster = !!document.querySelector('.photoposter-section');
  var toolType = isPetPoster ? 'Pet Poster' : isPhotoPoster ? 'Photo Poster' : null;

  if (!toolType) return;

  // ─── Started Design ────────────────────────────
  var productTitle = '';
  var productPrice = '';
  try {
    var titleEl = document.querySelector('h1, .product__title');
    if (titleEl) productTitle = titleEl.textContent.trim();
    var priceEl = document.querySelector('.price-item--regular, .price .money');
    if (priceEl) productPrice = priceEl.textContent.trim();
  } catch (e) {}

  track('Started Design', {
    tool: toolType,
    product_title: productTitle,
    product_price: productPrice
  });

  // ─── Pet Poster: Selected Style ────────────────
  if (isPetPoster) {
    // Track when illustration loads via URL params
    var urlParams = new URLSearchParams(window.location.search);
    var illustrationName = urlParams.get('illustration_name');
    if (illustrationName) {
      track('Selected Style', {
        tool: 'Pet Poster',
        style_name: decodeURIComponent(illustrationName),
        illustration_url: urlParams.get('illustration') || ''
      });
    }

    // Track Change Style button clicks
    document.addEventListener('click', function (e) {
      if (e.target.closest('.pp-change-style-btn, [data-change-style]')) {
        track('Browsing Styles', { tool: 'Pet Poster' });
      }
    });
  }

  // ─── Pet Poster: Uploaded Pet Photo ────────────
  if (isPetPoster) {
    // Listen for dropzone getting a photo
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === 'attributes' && m.attributeName === 'class') {
          var el = m.target;
          if (el.classList.contains('has-photo') && el.classList.contains('pp-dropzone')) {
            track('Uploaded Pet Photo', {
              tool: 'Pet Poster',
              is_duo: !!document.querySelector('.pp-duo-mode-active, [data-duo="true"]')
            });
          }
        }
      });
    });
    var dropzones = document.querySelectorAll('.pp-dropzone');
    dropzones.forEach(function (dz) {
      observer.observe(dz, { attributes: true });
    });

    // Also hook into the global handler
    var _origHandlePhoto = window.ppLoadPetPhotoFromLibrary;
    if (_origHandlePhoto) {
      window.ppLoadPetPhotoFromLibrary = function (url) {
        track('Uploaded Pet Photo', { tool: 'Pet Poster', source: 'library' });
        return _origHandlePhoto(url);
      };
    }
  }

  // ─── Photo Poster: Uploaded Photo ──────────────
  if (isPhotoPoster) {
    var ptpUpload = document.getElementById('ptp-direct-upload');
    var ptpFileInput = document.querySelector('.photposter-photo-input');
    [ptpUpload, ptpFileInput].forEach(function (input) {
      if (input) {
        input.addEventListener('change', function () {
          if (this.files && this.files.length) {
            track('Uploaded Pet Photo', { tool: 'Photo Poster', source: 'file_input' });
          }
        });
      }
    });
  }

  // ─── Pet Poster: Generated Portrait ────────────
  if (isPetPoster) {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.pp-generate-btn, #pp-generate-btn');
      if (btn) {
        track('Started Generating Portrait', { tool: 'Pet Poster' });

        // Watch for success (portrait URL input gets populated)
        var checkInterval = setInterval(function () {
          var portraitInput = document.querySelector('input[name="properties[__ai_portrait]"]');
          if (portraitInput && portraitInput.value) {
            track('Generated Portrait', {
              tool: 'Pet Poster',
              style_name: illustrationName || productTitle
            });
            clearInterval(checkInterval);
          }
        }, 2000);

        // Stop checking after 3 minutes
        setTimeout(function () { clearInterval(checkInterval); }, 180000);
      }
    });
  }

  // ─── Photo Poster: Applied Filter ──────────────
  if (isPhotoPoster) {
    document.addEventListener('change', function (e) {
      if (e.target.name === 'properties[__Filter]' || e.target.classList.contains('filter-radio-input')) {
        var label = '';
        try {
          var checked = document.querySelector('input[name="properties[__Filter]"]:checked');
          if (checked) {
            var labelEl = checked.closest('label') || checked.parentElement;
            label = labelEl ? labelEl.textContent.trim() : checked.value;
          }
        } catch (ex) {}
        track('Applied Filter', { tool: 'Photo Poster', filter_name: label || e.target.value });
      }
    });
  }

  // ─── Customized Text ───────────────────────────
  document.addEventListener('input', function (e) {
    if (e.target.classList.contains('bp-name-input') ||
        e.target.classList.contains('bp-breed-input') ||
        e.target.classList.contains('bp-custom-text-input')) {
      clearTimeout(_textTimer);
      _textTimer = setTimeout(function () {
        var heading = '';
        var subheading = '';
        try {
          heading = document.querySelector('.bp-pet-name') ? document.querySelector('.bp-pet-name').textContent.trim() : '';
          subheading = document.querySelector('.bp-photo-subheading, .bp-breed-text') ? document.querySelector('.bp-photo-subheading, .bp-breed-text').textContent.trim() : '';
        } catch (ex) {}
        track('Customized Text', {
          tool: toolType,
          heading: heading,
          subheading: subheading
        });
      }, 3000); // Wait 3s after last keystroke
    }
  });

  // ─── Added to Cart ─────────────────────────────
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches('form[action*="/cart/add"]') || form.id.indexOf('product-form') === 0) {
      var size = '';
      var frame = '';
      try {
        var sizeEl = document.querySelector('input[name="properties[__Size]"]:checked, select[name="properties[__Size]"]');
        if (sizeEl) size = sizeEl.value;
        var frameEl = document.querySelector('input[name="properties[__Frame]"]:checked, select[name="properties[__Frame]"]');
        if (frameEl) frame = frameEl.value;
      } catch (ex) {}

      var hasPortrait = false;
      var portraitInput = document.querySelector('input[name="properties[__ai_portrait]"]');
      if (portraitInput && portraitInput.value) hasPortrait = true;

      track('Added to Cart', {
        tool: toolType,
        product_title: productTitle,
        product_price: productPrice,
        has_portrait: hasPortrait,
        size: size,
        frame: frame
      });
    }
  });

})();
